import React, { useCallback, useEffect, useRef, useState } from 'react'
import TableCustom from '../../../../components/table/tableCustom';
import { ButtonBack, ButtonContained, ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import ContentHeading from '../../../../components/layout/content/ContentHeading';
import InputTextField from '../../../../components/input/inputTextField';
import { RemoveRedEyeOutlined, SearchOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { dateTimeToView } from '../../../../utils/date.utils';
import SwitchCustom from '../../../../components/switch/SwitchCustom';
import { useDispatch } from 'react-redux';
import ModalCustom from '../../../../components/modal/ModalCustom';
import { alertActive, alertError, swalError, swalSuccess } from '../../../../components/alert/swal';
import OptionsButtonCustom from '../../../../components/button/OptionsButtonCustom';
import { MeetingPositionApi } from '../../../../api/meeting-position/meeting-position.api';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';
import { MeetingExampleFileApi } from '../../../../api/manage-sample-files/manage-sample-files.api';
import { Box, Typography } from '@mui/material';

const defaultState = {
    id_meeting_room_file: 0,
    display_name: undefined
}
export default function ManageSampleFiles() {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const fileRef = useRef<any>()
    const [file, setFile] = useState<any>();
    const [search, setSearch] = useState<any>('')
    const [form, setForm] = useState<any>(defaultState)
    const [type, setType] = useState<string>("CREATE");
    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const [pathUrl, setPathUrl] = useState<string>("");
    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [
        {
            id: "#",
            width: '50px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("ลำดับ"),
        },
        {
            id: "leave_type_name",
            width: '300px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อไฟล์"),
        },
        {
            id: "center",
            disablePadding: false,
            width: '100px',
            sortable: false,
            align: "center",
            label: t("สกุล"),
        },
        {
            id: "center",
            disablePadding: false,
            width: '100px',
            sortable: false,
            align: "center",
            label: t("ขนาด"),
        },
        {
            id: "center",
            disablePadding: false,
            width: '100px',
            sortable: false,
            align: "center",
            label: t("สถานะ"),
        },
        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("วันที่สร้าง/ปรับปรุงล่าสุด"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const {
            id_meeting_room_file,
            display_name,
            status,
            file_type,
            file_size,
            modifier_name,
            modified_date } =
            objData;

        const objRenderData = {
            key: id_meeting_room_file,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "start",
                    label: display_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: file_type || '-',
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: file_size ? formatBytes(file_size) : '-',
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <SwitchCustom
                            checked={status === "active" ? true : false}
                            onChange={(value: boolean) => {
                                handleUpdateStatus(id_meeting_room_file, value ? "active" : "inactive");

                            }}
                        />
                    ),
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: modifier_name || '-',
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableEdit
                            enableDelete
                            enableDownload
                            onDownloadClick={() => {
                                getDownload(id_meeting_room_file)
                            }}
                            onViewClick={() => {
                                getById(id_meeting_room_file)
                                setType("VIEW")
                            }}

                            onEditClick={() => {
                                getById(id_meeting_room_file)
                                // setForm(objData)
                                setType("EDIT")
                            }}
                            onDeleteClick={() => {
                                alertActive(t('ยืนยันที่จะลบ หรือไม่?'), '', t('ยืนยัน'), t('ยกเลิก'), () => {
                                    handleDelete(id_meeting_room_file)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };

            const res = await MeetingExampleFileApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    const handleClose = async () => {
        setOpen(false)
        setForm(defaultState)
        setFile(null)
    }
    const getById = async (id_meeting_room_file: number) => {
        await MeetingExampleFileApi.findById(id_meeting_room_file).then((res: any) => {
            if (res.status < 300) {
                setOpen(true)
                setForm(res.data.data)
                setFile(res.data.data)
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })
    }
    const getDownload = async (id_meeting_room_file: number) => {
        await MeetingExampleFileApi.findById(id_meeting_room_file).then(async(res: any) => {
            if (res.status < 300) {
                window.open(pathUrl + '/' + res.data.data?.file_path + res.data.data?.file_name, '_blank')
                // const response = await fetch(pathUrl + '/' + res.data.data?.file_path + res.data.data?.file_name);
                // const blob = await response.blob();

                // const blobUrl = window.URL.createObjectURL(blob);
                // const a = document.createElement("a");
                // a.href = blobUrl;
                // a.download = res.data.data?.file_name || pathUrl + '/' + res.data.data?.file_path + res.data.data?.file_name.split("/").pop();
                // document.body.appendChild(a);
                // a.click();

                // // ล้าง blob URL
                // a.remove();
                // window.URL.revokeObjectURL(blobUrl);
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })
    }
    const handleUpdateStatus = async (id_meeting_room_file: number, status: any) => {
        await MeetingExampleFileApi.patch({ status: status }, id_meeting_room_file).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('MEETING_POSITION.EDIT_MEETING_POSITION_SUCCESS'))
                loadData()
                handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })
    }
    const handleCreate = async (id_meeting_room_file: any) => {
        const body = {
            id_meeting_room_file: id_meeting_room_file,
            display_name: form?.display_name,
            status: "active"
        };
        if (type === 'EDIT') {
            await MeetingExampleFileApi.patch(body, form.id_meeting_room_file).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('แก้ไขไฟล์ เรียบร้อย'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })

        } else {
            await MeetingExampleFileApi.post(body).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('อัพโหลดไฟล์ เรียบร้อย'))
                    loadData()
                    handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })

        }
    }

    const handleDelete = async (id: any) => {
        await MeetingExampleFileApi.delete(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบไฟล์เรียบร้อยเเล้ว'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t('เกิดข้อผิดพลาด'))
        })

    }
    const handleUpload = async () => {
        if (file?.id_meeting_room_file) {
            handleCreate(file?.id_meeting_room_file)
        } else {
            const formData = new FormData();
            formData.append('file', file);
            dispatch(setLoading());
            await MeetingExampleFileApi.uploadMeetingExampleFile(formData)
                .then((res) => {
                    if (res.status < 300) {
                        handleCreate(res.data.id_meeting_room_file)
                        if (fileRef.current) {
                            fileRef.current.value = null;
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("อัพโหลด"), t("อัพโหลด ไม่สำเร็จ"));
                    if (fileRef.current) {
                        fileRef.current.value = null;
                    }
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }
    }
    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    return (
        <div>
            <ContentHeading
                title={t("จัดการไฟล์ตัวอย่าง")}
                detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
            />

            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหาชื่อไฟล์, ชื่อ-นามสกุล")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            setSearch(e.target.value)
                        }}
                        value={search || ''}
                    />
                </article>

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-9 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    <ButtonPrimary
                        onClick={() => {
                            // navigate(routeName.cms.ManageLeaveType + `/create`);
                            setOpen(true)
                            setType('CREATE')
                        }}
                        mode="add"
                        buttonName={t("เพิ่มไฟล์")}
                    />
                </article>
            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
            <ModalCustom title={t('จัดการไฟล์ตัวอย่าง')} subTitle={t('กรุณาเลือกรายการที่ท่านต้องการ')} open={open} component={
                <div className='flex flex-col gap-4'>


                    <div className='w-full'>
                        <Box sx={{
                            // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                            padding: "10px 20px",
                            borderRadius: "20px",
                            // height: "500px",
                            border: '1px solid #DDE1EB',
                            cursor: 'pointer'
                        }}>
                            {file ?
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                                    <div>
                                        <Typography sx={{ fontSize: '16px' }}>{file?.name || file?.file_name}</Typography>
                                        <Typography>{formatBytes(file?.size || file?.file_size)}</Typography>
                                    </div>
                                    {type !== 'VIEW' && <ButtonContained buttonName={t('ลบไฟล์')} onClick={() => {
                                        setFile(null)
                                        if (fileRef.current) {
                                            fileRef.current.value = null;
                                        }
                                    }} />}

                                </div>
                                : <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                                    <div>
                                        <Typography sx={{ fontSize: '16px' }}>{t('เลือกไฟล์')}</Typography>
                                        {/* <Typography>{formatBytes(file?.size)}</Typography> */}
                                    </div>
                                    <ButtonContained buttonName={t('เลือกไฟล์')} onClick={() => { fileRef.current.click() }} />
                                </div>}

                        </Box>
                        <input ref={fileRef} className='hidden' type='file'
                            accept={"image/*"}
                            onChange={(e: any) => {
                                setFile(e.target.files[0])
                                setForm({ ...form, display_name: e.target.files[0]?.name })


                            }} />

                    </div>
                    <div>
                        <InputTextField
                            heading={t("ชื่อไฟล์")}
                            placeholder={t("ชื่อไฟล์")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setForm({ ...form, display_name: e.target.value })
                            }}
                            value={form.display_name || ''}
                            disabled={type === 'VIEW'}
                        />
                    </div>
                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleClose()
                            }}
                            buttonName={t('ยกเลิก')}
                        />
                        {type !== 'VIEW' && <ButtonPrimary
                            onClick={() => {
                                handleUpload()
                            }}
                            mode='add'
                            disabled={!file}
                            buttonName={t('ยืนยัน')}
                        />}
                    </div>
                </div>
            } />
        </div>
    )
}
